import React from "react";
import { Input, InputProps } from "antd";
import "./index.scss"

const InputField: React.FC<InputProps> = ({ ...restProps }) => {
  return <Input className="auth-pages-input" {...restProps} />;
};

export default InputField;
